
var Model = require("../types/Model.js");
var extender = Model.makeExtender;

module.exports = Model({
	name: "passwordreset",
	_code: undefined,
	init: init,
	listeners: listeners,
	triggers: triggers,
});

function init() {
	this.push({
		sending: false,
		sent: false,
		changing: false,
		changed: false,
		email: "",
		message: "",
		localization: {},
		save: false
	});
}

function listeners() {
	return {
		"localization:updated": handle_localization_update,
		"querystring:updated": handle_querystring_update,
		"toast:updated": extender("toast"),
		"save:updated": extender("save")
	};
}

function triggers() {
	return {
		"request": handle_trigger_reset_request,
		"reset": handle_trigger_reset
	};
}

function handle_querystring_update(querystring) {
	var code = querystring.code;
	this._code = code;
}

/**
 * Attempts to send out a password reset code via email
 */
function handle_trigger_reset_request(data) {
	var email = data.email;
	this.extend({
		sending: true
	});
	this.api.auth.password
		.request(email)
		.then(handle_reset_request_success.bind(this))
		.catch(handle_reset_request_error.bind(this));
	this.emit("usermetrics:trigger:track", "request password reset");
}

/**
 * Attempts to reset a person's password using their passwordreset code
 */
function handle_trigger_reset(data) {
	this.emit("save:trigger:start");

	var password = data.password;
	var confirm = data.confirm;
	var code = this._code;

	if (password !== confirm) {
		this.emit("usermetrics:trigger:track", "attempt to reset password but passwords do not match");
		return this.extend({
			message: "error_reset_password_confirm_different"
		});
	}

	if (!code) {
		this.emit("usermetrics:trigger:track", "attempt to reset password but no code was provided");
		return this.extend({
			message: "error_reset_password_code_invalid"
		});
	}

	this.extend({
		changing: true
	});

	this.api.auth.password
		.reset(code, password, confirm)
		.then(handle_reset_success.bind(this))
		.catch(handle_reset_error.bind(this));

	this.emit("usermetrics:trigger:track", "reset password");
}

/**
 * Marks password reset sending as successful
 */
function handle_reset_request_success() {
	this.extend({
		sending: false,
		sent: true
	});
}

/**
 * Handles errors during sending a password reset
 */
function handle_reset_request_error(err) {
	var code = err.status;
	var message = "passwordreset.errorunknown";
	var error_map = {
		400: "passwordreset.error400",
		404: "passwordreset.error404"
	};

	if (code in error_map)
		message = error_map[code];

	this.extend({
		sending: false,
		message: message
	});
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

/**
 * Marks a password reset as successful
 */
function handle_reset_success() {
	this.emit("save:trigger:finish");

	this.extend({
		changing: false,
		changed: true
	});
}

/**
 * Handles errors during resetting of the password
 */
function handle_reset_error(err) {
	this.emit("save:trigger:finish");

	console.error(err);
	var code = err.status;
	var message = "error_reset_password_unknown";
	var error_map = {
		404: "error_reset_code_invalid"
	};

	if (error_map[code])
		message = error_map[code];

	this.extend({
		changing: false,
		message: message
	});
}

/**
 * Handles changes in localization. Updates `localization` state.
 * @param  {Object} data The state of the Localization model. Contains `localization` map.
 */
function handle_localization_update(data) {
	this.extend({
		localization: data.localization
	});
}
